import { ragStatus, taskPlanTypes, taskStatus, yesNoOptions } from 'src/consts.js'

export const ragStatusIcons = {
    [ragStatus.RED]: 'clear',
    [ragStatus.AMBER]: 'error_outline',
    [ragStatus.GREEN]: 'done',
}

export const yesNoNaIcons = {
    [yesNoOptions.YES]: 'done',
    [yesNoOptions.NO]: 'clear',
    [yesNoOptions.NOT_APPLICABLE]: 'block',
}

export const taskPlanTypeIcons = {
    [taskPlanTypes.TYPE_HEALTH_AND_SAFETY]: 'medical_services',
    [taskPlanTypes.TYPE_RISK]: 'flash_on',
    [taskPlanTypes.TYPE_SAFETY_IN_DESIGN]: 'build',
    [taskPlanTypes.TYPE_ENVIRONMENTAL]: 'business',
    [taskPlanTypes.TYPE_SUSTAINABILITY]: 'spa',
    [taskPlanTypes.TYPE_OTHER]: 'description',
    [taskPlanTypes.TYPE_HSE_RISK_REGISTER]: 'flash_on',
}

export const taskStatusIcons = {
    [taskStatus.STATUS_SCHEDULED]: 'calendar_month',
    [taskStatus.STATUS_TENATIVE]: 'calendar_month',
    [taskStatus.STATUS_IN_PROGRESS]: 'event_repeat',
    [taskStatus.STATUS_COMPLETE]: 'event_available',
    [taskStatus.STATUS_CANCELLED]: 'event_busy',
}
